(function () {
  'use strict';

  if (window.AirwinksCartLoader) return;
  window.AirwinksCartLoader = true;
  window.AirwinksCartFixVersion = '2026-09-01.3';

  if (window.Element && !Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }

  if (window.Element && !Element.prototype.closest) {
    Element.prototype.closest = function (selector) {
      var element = this;
      while (element && element.nodeType === 1) {
        if (element.matches(selector)) return element;
        element = element.parentElement;
      }
      return null;
    };
  }

  function eventElement(target) {
    var element = target;
    while (element && element.nodeType !== 1) element = element.parentNode;
    return element || null;
  }

  function closestTarget(target, selector) {
    var element = eventElement(target);
    return element && element.closest ? element.closest(selector) : null;
  }

  function cartForm() {
    return document.querySelector('[data-aw-cart-page-form]');
  }

  function quantityInput(form, key) {
    var inputs = form.querySelectorAll('[data-aw-cart-quantity-input]');
    var index;

    for (index = 0; index < inputs.length; index += 1) {
      if (inputs[index].getAttribute('data-aw-cart-key') === key) return inputs[index];
    }

    return null;
  }

  function installCartPageFallback() {
    var form = cartForm();
    if (!form) return false;

    var submitting = false;

    function submitUpdate() {
      if (submitting) return;
      submitting = true;

      var marker = form.querySelector('input[data-aw-native-update]');
      if (!marker) {
        marker = document.createElement('input');
        marker.type = 'hidden';
        marker.name = 'update';
        marker.value = 'Update cart';
        marker.setAttribute('data-aw-native-update', '');
        form.appendChild(marker);
      }

      form.setAttribute('aria-busy', 'true');
      HTMLFormElement.prototype.submit.call(form);
    }

    document.addEventListener('click', function (event) {
      var quantityButton = closestTarget(event.target, '[data-aw-cart-quantity]');
      if (quantityButton) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        var key = quantityButton.getAttribute('data-aw-cart-key');
        var input = quantityInput(form, key);
        if (!input) return;

        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = 0;

        var delta = parseInt(quantityButton.getAttribute('data-delta'), 10);
        if (isNaN(delta)) delta = 0;

        input.value = String(Math.max(0, current + delta));
        submitUpdate();
        return;
      }

      var removeButton = closestTarget(event.target, '[data-aw-cart-remove]');
      if (removeButton) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

        var removeInput = quantityInput(form, removeButton.getAttribute('data-aw-cart-key'));
        if (!removeInput) return;
        removeInput.value = '0';
        submitUpdate();
      }
    }, true);

    document.addEventListener('change', function (event) {
      var input = closestTarget(event.target, '[data-aw-cart-quantity-input]');
      if (!input || !form.contains(input)) return;

      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      var quantity = parseInt(input.value, 10);
      input.value = String(isNaN(quantity) ? 0 : Math.max(0, quantity));
      submitUpdate();
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;

      var submitter = event.submitter || document.activeElement;
      var name = submitter && submitter.getAttribute ? submitter.getAttribute('name') : '';
      if (name === 'checkout') return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      submitUpdate();
    }, true);

    var page = document.querySelector('[data-aw-cart-page]');
    if (page) page.setAttribute('data-aw-cart-ready', 'native');
    return true;
  }

  if (installCartPageFallback()) return;

  function findLoaderScript() {
    if (document.currentScript && document.currentScript.src) return document.currentScript;

    var scripts = document.getElementsByTagName('script');
    var index;
    for (index = scripts.length - 1; index >= 0; index -= 1) {
      var source = scripts[index].getAttribute('src') || '';
      if (source.indexOf('airwinks-cart.js') !== -1) return scripts[index];
    }

    return null;
  }

  function sourceDetails(source) {
    var details = { base: '', version: '' };

    try {
      var parsed = new URL(source, window.location.href);
      details.base = parsed.href.slice(0, parsed.href.lastIndexOf('/') + 1);
      details.version = parsed.searchParams ? parsed.searchParams.get('v') || '' : '';
      return details;
    } catch (error) {
      var hashless = String(source || '').split('#')[0];
      var queryIndex = hashless.indexOf('?');
      var path = queryIndex === -1 ? hashless : hashless.slice(0, queryIndex);
      details.base = path.slice(0, path.lastIndexOf('/') + 1);
      return details;
    }
  }

  var loaderScript = findLoaderScript();
  if (!loaderScript || !loaderScript.src) {
    window.AirwinksCartLoader = false;
    return;
  }

  var details = sourceDetails(loaderScript.src);
  if (!details.base) {
    window.AirwinksCartLoader = false;
    return;
  }

  function load(name) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = details.base + name + (details.version ? '?v=' + encodeURIComponent(details.version) : '');
      script.async = false;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  load('airwinks-cart-ui.js')
    .then(function () { return load('airwinks-cart-lines.js'); })
    .then(function () { return load('airwinks-cart-product.js'); })
    .catch(function (error) {
      window.AirwinksCartLoader = false;
      if (window.console && console.error) console.error('Airwinks cart scripts could not be loaded.', error);
    });
})();
